import { render, staticRenderFns } from "./Requisition.vue?vue&type=template&id=fbd25d3a&scoped=true&"
import script from "./Requisition.vue?vue&type=script&lang=js&"
export * from "./Requisition.vue?vue&type=script&lang=js&"
import style0 from "./Requisition.vue?vue&type=style&index=0&id=fbd25d3a&prod&lang=css&"
import style1 from "./Requisition.vue?vue&type=style&index=1&id=fbd25d3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd25d3a",
  null
  
)

export default component.exports